import gql from 'graphql-tag';

export const ADD_CART_TO_PROJECTS = gql`
	mutation AddCartToProjects($projectInputs: [AddCartToProjectInput!]!) {
		addCartToProjects(projectInputs: $projectInputs)
	}
`;
